import { Component } from 'preact';
import style from './style.scss';

/**
 * The Tabs component displays a series of tabs in a row. Note that the tabs
 * do not wrap, so make sure that not too many are used as they will not fit
 * on a small screen.
 *
 * props:
 * - options: array of data objects, one for each tab. { id: any, label: string }[]
 * - selectedId: the id of the selected tab (should match one of the ids in props.options)
 * - tabSelected: function called when the user selects a non-active tab
 * - isSecondary: true if the secondary, smaller, flat version of tabs is desired, e.g. for use within a card
 */
class Tabs extends Component {

	constructor(props) {
		super(props);
		this.onTabClick = this.onTabClick.bind(this);
		this.onTabKeyPress = this.onTabKeyPress.bind(this);
	}

	onTabClick(evt) {
		if (evt.target.hasAttribute('data-index')) {

			const index = Number(evt.target.getAttribute('data-index'));

			const option = this.props.options[index];

			if (option.id !== this.props.selectedId) {
				this.props.tabSelected(option);
			}

		}
	}

	onTabKeyPress(evt) {
		if (evt.keyCode === 13) {
			this.onTabClick(evt);
		}
	}

	render(props) {
		const cssClasses = [style.tabs];

		if (props.isSecondary) {
			cssClasses.push(style.secondary);
		}

		return (
			<ul class={cssClasses.join(' ')} onClick={this.onTabClick} onKeyPress={this.onTabKeyPress}>
				{
					props.options.map((opt, i) => {
						const cssClasses = [style.tab];

						if (opt.id === props.selectedId) {
							cssClasses.push(style.tab_active);
						}

						return (
							<li tabIndex="0" key={opt.id} data-index={i} class={cssClasses.join(' ')}>{ opt.label }</li>
						);
					})
				}
			</ul>
		);
	}

}

export default Tabs;



// WEBPACK FOOTER //
// ./components/tabs/index.js